<template>
    <div>
        <nav>
            <!--하단 내비 메뉴 -->
            <a href="#" id="m_Home" class="nav_item" 
            :class="{active_menu:activeMenu('m_Home')}" 
            @click="active_nav('m_Home')">
                <div>
                    <span><font-awesome-icon :icon="['fas', 'play']" /></span>
                    <span>홈</span>
                </div>
            </a>           
            <a href="#"  id="m_ItemList" class="nav_item"  
            :class="{active_menu:activeMenu('m_ItemList')}" 
             @click="active_nav('m_ItemList')">
                <div>
                    <span><font-awesome-icon :icon="['fas', 'magic']" /></span>
                    <span>아이템</span>
                </div>
            </a>
            <a href="#"  id="m_ChatLobby" class="nav_item"              
            @click="active_nav('m_ChatLobby')">
                <div>
                    <span><font-awesome-icon :icon="['fas', 'comments']" /></span>
                    <span>채팅</span>
                </div>
            </a>  
            <a href="#" id="nav_myinfo" class="nav_item" @click="active_myinfo()">
                <div>
                    <span><font-awesome-icon icon="user"/></span>
                    <span>내정보</span>
                </div>
            </a>                         
        </nav> 
        <div id="myinfo" class="myinfoPage ">               
            <my-info @close-myinfo="active_myinfo"/>
        </div>  
    </div>
</template>
<script>
import MyInfo from '@/mobile/MyInfo'
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{
            view_myinfo:false
        }
    },
    mixins:[

    ],
    components:{
        MyInfo
    },   
    mounted(){
        this.nav_active(this.getActiveMobileMenu);
    },    
    computed:{
        getActiveMobileMenu(){
            return this.$store.state.menu.activeMobileMenu;
        }
    },
    methods:{
        link_chat(){
            //alert('준비중입니다.채팅은 PC버전을 이용해 주세요!');
            //return;
            this.$router.push({name:'m_chat_main'});
        },
        active_nav(routename)
        {           
            document.querySelector('#myinfo').classList.remove('view_myinfo'); 
            this.nav_active(routename);   
            this.$router.push({name:routename});
            this.$store.commit("menu/setActiveMobileMenu", routename);
        },
        activeMenu(input){
            return input === this.$store.state.menu.activeMobileMenu;
        },
        active_myinfo()
        {   
            let link = false;
            if(document.querySelector('#myinfo').classList.contains('view_myinfo') )
            {
                link = true;
            }
            document.querySelector('#myinfo').classList.toggle('view_myinfo'); 
            //view_myinfo 가 있으면 
           
            this.nav_active('nav_myinfo',link);
               
           
            //event.target.classList.toggle('active_menu');      
            //this.view_myinfo = !this.view_myinfo;
           
        },       
        nav_active(nav_id,link)
        {
            let elements = document.querySelectorAll('.nav_item');
            
            // remove class from all chosen elements
            for (var i=0; i<elements.length; i++) {    
                if(elements[i].id !== nav_id){
                     elements[i].classList.remove('active_menu');            
                }                                     
            }
            if(link){
                document.querySelector('#' + nav_id).classList.toggle('active_menu');  
                this.nav_active(this.$route.name); 
            }else{
                document.querySelector('#' + nav_id).classList.add('active_menu');    
            }
            
        }    
    }
}
</script>
<style lang="scss" scoped>
 nav{     
    position: fixed;   
    bottom:0px;
    left:0px;
    height:55px;
    z-index: 10;
    width:100%;
    background-color: rgb(255, 255, 255);
    display: flex;
    border-top:1px solid rgba(229,231,235,.5);
    justify-content: space-around;  
    
    .nav_item{
        text-decoration: none;
        color: rgb(134, 134, 134);
        display: flex;
        flex: 1 1 0%;
        align-items: center;
        justify-content: center;
        flex-direction: column; 
        text-align: center;
        span:first-child{
            display: block;
            font-size: 1.3rem;               
            line-height: 2rem;
        }   
        span:nth-child(2){
            font-size: 10px;
            line-height: 1;
            display: block;
            
        } 
    }
    .active_menu{
        color:rgb(60, 0, 88);
    }
}
nav::before{
    content: "";
    display: block;
    position: absolute;
    top: -6px;
    right: 0px;
    left: 0px;
    height: 6px;
    background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.05));    
}
.myinfoPage{
    position: fixed;
    right:0px;
    top:0px;
    background:#fff;
    width: 100%;
    height: calc(100% - 55px);
    transform: translateX(100%);
    transition: transform 0.3s ease-in 0s;
    display: flex;
    flex-direction: column;   
    z-index: 99;      
}    
.view_myinfo{           
    transform: translateX(0px);            
}       
</style>